'use client';

import Icon from '@/components/ui/AppIcon';

export default function BenefitsSection() {
  const benefits = [
    {
      stat: '30%',
      label: 'Average Cost Savings',
      description: 'Compared to traditional hotel corporate rates',
      icon: 'CurrencyDollarIcon'
    },
    {
      stat: '95%',
      label: 'Employee Satisfaction',
      description: 'Reported improved comfort and productivity',
      icon: 'FaceSmileIcon'
    },
    {
      stat: '24/7',
      label: 'Dedicated Support',
      description: 'Round-the-clock assistance for your team',
      icon: 'ClockIcon'
    },
    {
      stat: '15+',
      label: 'Corporate Partners',
      description: 'Trusted by leading companies across industries',
      icon: 'BuildingOfficeIcon'
    }
  ];

  const testimonials = [
    {
      quote: 'Proximus has transformed our corporate housing program. The cost savings are significant, and our relocating employees consistently praise the quality and comfort of the apartments.',
      author: 'Sarah Mitchell',
      role: 'HR Director, Tech Solutions Inc.',
      company: 'Fortune 500 Technology Company'
    },
    {
      quote: 'The dedicated account management and flexible billing have streamlined our travel operations. The booking portal integrates seamlessly with our approval workflows.',
      author: 'Rajesh Kumar',
      role: 'Travel Manager, Global Consulting Group',
      company: 'International Consulting Firm'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary via-secondary to-primary">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
            <Icon name="TrophyIcon" size={20} className="text-accent" />
            <span className="text-white text-sm font-medium">Proven Results</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-white mb-6">
            Why Companies Choose Proximus
          </h2>
          <p className="text-lg text-white/90">
            Real results from corporate clients who have transformed their accommodation programs with our solutions.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <Icon name={benefit.icon as any} size={40} className="text-accent mx-auto mb-4" />
              <div className="text-4xl font-display font-bold text-white mb-2">
                {benefit.stat}
              </div>
              <div className="text-lg font-semibold text-white mb-2">
                {benefit.label}
              </div>
              <p className="text-sm text-white/80">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-8">
              <div className="flex items-start space-x-2 mb-4">
                <Icon name="ChatBubbleLeftEllipsisIcon" size={32} className="text-accent flex-shrink-0" />
                <p className="text-white/90 italic leading-relaxed">
                  "{testimonial.quote}"
                </p>
              </div>
              <div className="border-t border-white/20 pt-4">
                <p className="font-semibold text-white">{testimonial.author}</p>
                <p className="text-sm text-white/80">{testimonial.role}</p>
                <p className="text-xs text-white/60 mt-1">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}